import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { Util } from '../util.service';

@Injectable({
  providedIn: 'root'
})

export class LevelService {
  baseurl = Util.GetBaseUrl();

  constructor(private http: HttpClient, public router: Router) { }

  viewLevel() {
    return this.http.get(this.baseurl +'/api/Levels/GetLevels')
  }

  addLevel(levelForm) {
    console.log(levelForm);
    return this.http.post(this.baseurl+'/api/Levels', levelForm)
  }

  editLevel(id, levelForm) {
    console.log(id);
    return this.http.put(this.baseurl +`/api/Levels/${id}`, levelForm)
  }

  deleteLevel(id) {
    console.log(id);
    return this.http.delete(this.baseurl+`/api/Levels/${id}`)
  }
}
